/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which duplicate is kept?`)
};

const es_rd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál duplicado se mantiene?`)
};

const de_rd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welches Duplikat wird behalten?`)
};

const nl_rd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welk duplicaat wordt behouden?`)
};

const fr_rd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel doublon est conservé ?`)
};

const it_rd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale duplicato viene mantenuto?`)
};

const pt_br2_rd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual duplicata é mantida?`)
};

const pt_rd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual duplicata é mantida?`)
};

const ja_rd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの重複が保持されますか?`)
};

const zh_rd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保留的是哪一个重复项？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_faq1_q", locale)
	if (locale === "en") return en_rd_faq1_q(inputs)
	if (locale === "es") return es_rd_faq1_q(inputs)
	if (locale === "de") return de_rd_faq1_q(inputs)
	if (locale === "nl") return nl_rd_faq1_q(inputs)
	if (locale === "fr") return fr_rd_faq1_q(inputs)
	if (locale === "it") return it_rd_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_rd_faq1_q(inputs)
	if (locale === "pt") return pt_rd_faq1_q(inputs)
	if (locale === "ja") return ja_rd_faq1_q(inputs)
	return zh_rd_faq1_q(inputs)
};